/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GoalsRoute extends Route {
  // Services
  @service
  options;

  @service
  store;

  @service
  router;

  model() {
    return hash({
      badges: this.store.query('goals/badge', {
        personId: this.get('session.personId'),
      }),
    });
  }

  beforeModel() {
    // If student goal setting is not enabled, redirect to the home page.
    // This covers subroutes too - i.e. goals.index and goals.plp will both be caught by this.
    if (!this.options.value('core:studentGoalSetting:enabled')) {
      this.router.transitionTo('home');
    }
  }

  setupController(controller) {
    super.setupController(...arguments);
    // The controller owns the goal queries, but the route decides when they
    // run - see GoalsController#load.
    controller.load();
  }

  activate() {
    super.activate(...arguments);
    this.controllerFor('application').set('currentPageId', null);
    this.controllerFor('application').set('isViewingGoals', true);
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('application').set('isViewingGoals', false);
  }
}
